import {Component, Input, Output, EventEmitter, ChangeDetectionStrategy} from '@angular/core';
import {Action} from 'src/app/models/layout';
import {keyExistsIn} from "../../../../utils/generic";

@Component({
	selector: 'app-custom-row-actions',
	templateUrl: './custom-row-actions.component.html',
	styleUrls: ['./custom-row-actions.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class CustomRowActionsComponent
{
	@Input() actions: Action[] | null = null;
	@Input() row: any;
	@Input() rowIndex!: number;
	@Input() isEditing = false;
	@Input() isCanceled = false;
	@Input() isDeleted = false;

	@Output() action = new EventEmitter<{ action: string; rowIndex: number; row?: any }>();

	constructor()
	{
	}

	emitAction(actionId: string): void
	{

		this.action.emit({action: actionId, rowIndex: this.rowIndex, row: this.row});
	}

	keyExistsIn = keyExistsIn;
}
